import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions, combineActions } from 'redux-actions';
import { reduxKey, defaultState } from './constants';
import { enterZoomMode, exitZoomMode, showPanel, hidePanel, hidePanelPopup, setScreenSize, initStash } from './actions';
import { setViewMode } from '../../publicSession/actions';
import { unloadDuperbrowseItem, exitDuperbrowseDone } from '../../Duperbrowse/redux/actionCreators';
const actionHandlers = handleActions({
    [setViewMode.toString()]: (state, { payload: { nextViewMode, currentViewMode } })=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                isInZoom: nextViewMode !== currentViewMode ? false : state.viewOptions.isInZoom
            })
        }),
    [enterZoomMode.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                isInZoom: true
            })
        }),
    [exitZoomMode.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                isInZoom: false
            })
        }),
    [showPanel.toString()]: (state, { payload: { actionBar = 'primary', panelType } })=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                visiblePanel: panelType,
                activeActionBar: actionBar
            })
        }),
    [hidePanel.toString()]: (state, { payload: { panelType } })=>state.viewOptions.visiblePanel === panelType ? _object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                visiblePanel: false,
                activeActionBar: 'primary'
            })
        }) : state,
    [combineActions(unloadDuperbrowseItem, exitDuperbrowseDone).toString()]: (state)=>state.viewOptions.visiblePanel ? _object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                visiblePanel: false,
                activeActionBar: 'primary',
                isInZoom: false
            })
        }) : _object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                isInZoom: false
            })
        }),
    [hidePanelPopup.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                visiblePanel: false,
                activeActionBar: 'primary'
            })
        }),
    [setScreenSize.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                screenSize: action.payload
            })
        }),
    [initStash.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            stash: action.payload.stash
        })
}, defaultState);
export default {
    [reduxKey]: actionHandlers
};

//# sourceMappingURL=reducer.js.map